import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ButtonGroup,
  Spinner
} from "reactstrap";

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  confirmationPrompt: PropTypes.string,
  isProcessing: PropTypes.bool,
  processingMessage: PropTypes.string,
  error: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
    additionalDetails: PropTypes.string
  })
};

const AdminActionModal = ({
  isOpen,
  onClose,
  onConfirm = null,
  confirmationPrompt = null,
  isProcessing = false,
  processingMessage = "Processing, please wait...",
  error = null
}) => {
  const isConfirming = !isProcessing && !error;

  return (
    <Modal
      isOpen={isOpen}
      toggle={isProcessing ? undefined : onClose}
      size="lg"
      fade={false}
      className="account-app modal-dialog-centered"
    >
      <ModalHeader toggle={isProcessing ? undefined : onClose} className="p-2" />
      <ModalBody className="px-4 pt-0 pb-3 text-center">
        {isProcessing && (
          <>
            <Spinner color="primary" className="mb-3" />
            <p>{processingMessage}</p>
          </>
        )}
        {!isProcessing && isConfirming && confirmationPrompt && (
          <p className="confirmation-prompt">{confirmationPrompt}</p>
        )}
        {error && (
          <>
            <h5 className="font-weight-bold mb-3 text-danger">Error</h5>
            <p className="text-muted">{error.title}</p>
            {error.message && (
              <pre className="text-left bg-light p-2 rounded pre-scrollable">
                <small>{error.message}</small>
              </pre>
            )}
            {error.additionalDetails && (
              <pre className="text-left bg-light p-2 rounded pre-scrollable mt-2">
                <small>{error.additionalDetails}</small>
              </pre>
            )}
          </>
        )}
      </ModalBody>
      {!isProcessing && (
        <ModalFooter>
          {isConfirming && confirmationPrompt ? (
            <ButtonGroup>
              <Button color="primary" className="btn-sharp mx-1" onClick={onConfirm}>
                Confirm
              </Button>
              <Button color="secondary" className="btn-sharp mx-1" onClick={onClose}>
                Cancel
              </Button>
            </ButtonGroup>
          ) : (
            <Button color="primary" className="btn-sharp" onClick={onClose}>
              Close
            </Button>
          )}
        </ModalFooter>
      )}
    </Modal>
  );
};

AdminActionModal.propTypes = propTypes;

export default AdminActionModal;
